import React, { useMemo } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"

import { SellerType, Purpose, PurposesContent } from "@/models"

import { CompletedItem } from "./completed-item"
import { ToDoItem } from "./to-do-item"

const List = styled.ul`
  list-style-type: none;
  margin: ${spacing.xxSmall} ${spacing.none} ${spacing.none};
  padding: ${spacing.none};
`

type PurposeListProps = {
  purposes: Purpose[]
  purposesContent: PurposesContent
  sellerType: SellerType
  paypalTheme?: boolean
}

export const PurposeList: React.FC<PurposeListProps> = ({
  purposes,
  purposesContent,
  sellerType,
  paypalTheme,
}) => {
  const { text } = useLocalization()
  const completedPurposes: Purpose[] = useMemo(
    () => purposes.filter((purpose: Purpose) => purpose.status === "done"),
    [purposes],
  )
  const toCompletePurposes: Purpose[] = useMemo(
    () => purposes.filter((purpose: Purpose) => purpose.status !== "done"),
    [purposes],
  )

  return (
    <>
      {toCompletePurposes.map((purpose: Purpose) => (
        <ToDoItem
          key={purpose.documentPurposeType}
          documentType={purpose.documentPurposeType}
          icon={purposesContent[sellerType][purpose.documentPurposeType].icon}
          name={purposesContent[sellerType][purpose.documentPurposeType].name}
          description={purposesContent[sellerType][purpose.documentPurposeType].text}
          paypalTheme={paypalTheme}
        />
      ))}
      {completedPurposes.length > 0 && (
        <List role="list" aria-label={text("COMPLETED_TASKS_LIST_TITLE")}>
          {completedPurposes.map((purpose: Purpose) => (
            <CompletedItem
              key={purpose.documentPurposeType}
              name={purposesContent[sellerType][purpose.documentPurposeType].name}
              description={text("AUTOMATIC_PHOTOID_VERIFICATION_DOCUMENT_STATUS_IN_REVIEW")}
            />
          ))}
        </List>
      )}
    </>
  )
}
